import React, { Component } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash.get';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { connectRequest } from 'redux-query';
import { reduxForm, SubmissionError } from 'redux-form';
import { fetchAccountPacks, updateAccountPacks } from 'dash-front/admin/actions/accounts';
import Snackbar from 'material-ui/Snackbar';
import CircularProgress from 'material-ui/CircularProgress';
import { red400 } from 'material-ui/styles/colors';
import SectionList from './SectionList';
import PacksForm from '../forms/PacksForm';
import { SectionWrapper } from '../style';

const Loader = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 150px;
`;

const Text = styled.h3`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 80px;
    font-size: 1.6em;
`;

const ErrorText = Text.extend`
    color: ${red400};
`;

class PacksSection extends Component {
    state = {
        snackbarSave: false
    };

    componentWillReceiveProps({ submitSucceeded }) {
        if (this.props.submitSucceeded !== submitSucceeded) {
            this.showSnackbarSave(submitSucceeded);
        } else {
            this.showSnackbarSave(false);
        }
    }

    showSnackbarSave = submitSucceeded => {
        this.setState({
            snackbarSave: submitSucceeded
        });
    };

    render() {
        const { snackbarSave } = this.state;
        const {
            packs = {},
            listPacks = [],
            userPacksList = [],
            isFinished = false,
            responseStatus = 0,
            submit,
            submitting = false,
            submitFailed = false
        } = this.props;

        if (!isFinished) {
            return (
                <Loader>
                    <CircularProgress size={80} thickness={5} />
                </Loader>
            );
        }

        if (responseStatus !== 200) {
            return <ErrorText>Error load packs</ErrorText>;
        }

        if (!listPacks.length) return <Text>Packs not found</Text>;

        return (
            <SectionWrapper>
                <SectionList
                    title="Packs"
                    Component={PacksForm}
                    submit={submit}
                    submitFailed={submitFailed}
                    packs={packs}
                    listPacks={listPacks}
                    userPacksList={userPacksList}
                />
                <Snackbar open={submitting} message="Packs saving..." autoHideDuration={10000} />
                <Snackbar open={snackbarSave} message="Packs save" autoHideDuration={3000} />
            </SectionWrapper>
        );
    }
}

PacksSection.propTypes = {
    userPacksList: PropTypes.array.isRequired,
    // From connect
    packs: PropTypes.object.isRequired,
    listPacks: PropTypes.array.isRequired,
    isFinished: PropTypes.bool.isRequired,
    responseStatus: PropTypes.number.isRequired,
    // From reduxForm
    submit: PropTypes.func,
    submitting: PropTypes.bool.isRequired,
    submitSucceeded: PropTypes.bool.isRequired,
    submitFailed: PropTypes.bool.isRequired
};

export default compose(
    connectRequest(() => fetchAccountPacks()),
    connect(({ query = { entities: {}, queries: {} } }, { userPacksList }) => {
        const packs = get(query.entities, 'accountPacks', {});
        const listPacks = Object.keys(get(query.entities, 'accountPacks', {})) || [];
        const initialValues = {
            accountPacks: listPacks.length
                ? listPacks.reduce((acc, packId) => {
                      const pack = packs[packId];

                      return { ...acc, [`${pack.id}`]: userPacksList.indexOf(pack.id) !== -1 };
                  }, {})
                : {}
        };

        return {
            packs,
            listPacks,
            isFinished: get(query.queries, ['GET:accountPacks', 'isFinished'], false),
            responseStatus: get(query.queries, ['GET:accountPacks', 'status'], 0),
            initialValues
        };
    }),
    reduxForm({
        form: 'editAccountPacks',
        onSubmit: ({ accountPacks }, dispatch, { userId }) => {
            const packsList = Object.entries(accountPacks).reduce((acc, [packName, isActive]) => {
                if (isActive) return [...acc, packName];

                return acc;
            }, []);

            return dispatch(updateAccountPacks(userId, { packs: packsList })).then(({ body, status }) => {
                if (status >= 400) {
                    throw new SubmissionError(body);
                }
            });
        },
        pure: true,
        enableReinitialize: true
    })
)(PacksSection);



/** WEBPACK FOOTER **
 ** ../src/dash/front/admin/components/Account/UpdateAccount/PacksSection.js
 **/